import {action, observable, makeObservable} from 'mobx';

import {posthogCapture} from '../utils/posthog-utils';
import {posthogEvents} from '../posthog-events';

//helpers
import ChangePasswordForm, {
  createLocalisedForm as createChangePasswordLocalisedForm
} from '../stores/forms/change-password-form';

import ErrorCodes from '../login-errors';
import {isEmpty} from 'lodash';

class ChangePasswordPage {
  form = ChangePasswordForm;
  translations = {};
  @observable passwordsMatch = true;
  @observable isValidNewPassword = true;
  @observable isInputFocused = false;
  @observable errorMessage = null;
  @observable errorCode = null;
  @observable showChangePasswordForm = true;
  @observable hasChangePasswordError = false;

  setNotification = notification => {
    this.notification = notification;
  };

  @action
  reset = () => {
    this.form.reset();
    this.errorCode = null;
    this.errorMessage = null;
    this.showChangePasswordForm = true;
  };

  @action
  setIsInputFocused = isInputFocused => {
    this.isInputFocused = isInputFocused;
  };

  @action
  setHasChangePasswordError = val => {
    this.hasChangePasswordError = val;
  };

  @action validatePassword = (updatePasswordMutation, store) => {
    const {newPassword, newPasswordConfirm} = this.form.values();
    this.isValidNewPassword = this.isPasswordValid(newPassword);
    if (this.isValidNewPassword) {
      this.passwordsMatch = newPassword === newPasswordConfirm;
      if (!this.passwordsMatch) {
        this.errorCode = null;
        this.errorMessage = null;
      }
    }
    if (this.passwordsMatch && this.isValidNewPassword) {
      this.submit(updatePasswordMutation, store);
    }
  };

  @action
  submit = (updatePasswordMutation, store) => {
    const {
      router,
      auth: {logout},
      app: {views}
    } = store;
    const {oldPassword, newPassword} = this.form.values();

    const updatePassword = {oldPassword, newPassword};

    updatePasswordMutation({updatePassword})
      .then(data => {
        if (!isEmpty(data.errors)) {
          this.errorMessage = data.errors[0].extensions.code;
          this.errorCode = data.errors[0].message;
          if (this.errorCode === ErrorCodes.BLOCKED) {
            this.showChangePasswordForm = false;
          }
        } else {
          posthogCapture(posthogEvents.changePasswordSuccessful);
          this.notification.success(this.translations.changedPassword);
          logout();
          router.goTo(views.domainLogin, {});
          this.reset();
        }
      })
      .catch(() => {
        if (!this.hasChangePasswordError) {
          this.notification.error(this.translations.canNotChangePassword);
        }
      });
  };

  constructor() {
    makeObservable(this);
  }

  setTranslations(translations) {
    this.translations = translations;
    this.form = createChangePasswordLocalisedForm(translations);
  }

  isPasswordValid(password) {
    const hasMinCharacters = password.length >= 8;
    const hasLowercaseChar = /[a-z]/.test(password);
    const hasUppercaseChar = /[A-Z]/.test(password);
    const containsNumber = /\d/.test(password);
    const containsNonAlphaChar = /[^a-zA-Z0-9\s:]/.test(password);
    const isPasswordValid =
      hasMinCharacters && hasLowercaseChar && hasUppercaseChar && containsNumber && containsNonAlphaChar;
    if (isPasswordValid) {
      return true;
    } else {
      this.passwordsMatch = true;
      this.errorCode = null;
      this.errorMessage = null;
      return false;
    }
  }
}

export default ChangePasswordPage;
